/* eslint-disable @typescript-eslint/no-explicit-any */
// GenAIOps widget registry entries (simple definitions for the widget picker / registry).
// These are distinct from the rich GENAIOPS_WIDGETS in genaiopsWidgets.ts which include getData functions.

import {
  REGISTRY_WIDGET_CATEGORIES,
  REGISTRY_WIDGET_SIZES,
  REGISTRY_WIDGET_TYPES,
  REGISTRY_ICONS,
} from './widgetRegistryConstants';

const C = REGISTRY_WIDGET_CATEGORIES;
const S = REGISTRY_WIDGET_SIZES;
const T = REGISTRY_WIDGET_TYPES;

export const GENAIOPS_REGISTRY_WIDGETS = [
  // GENAIOPS WIDGETS
  {
    id: 'total-traces',
    name: 'Total Traces',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'All LLM invocations tracked',
    icon: REGISTRY_ICONS.FiSearch,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'total-llm-cost',
    name: 'Total LLM Cost',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Spending on LLM services',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'average-latency',
    name: 'Average Latency',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Mean LLM response time',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'genaiops-error-rate',
    name: 'Error Rate',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Percentage of failed requests',
    icon: REGISTRY_ICONS.FiAlertCircle,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'traces-over-time',
    name: 'Traces Over Time',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Historical trace volume',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'model-usage-distribution',
    name: 'Cost by Model',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Cost breakdown by model',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'total-sessions',
    name: 'Total Sessions',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Conversation sessions tracked',
    icon: REGISTRY_ICONS.FiMessageSquare,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'genaiops-tokens',
    name: 'Total Tokens',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total tokens processed',
    icon: REGISTRY_ICONS.FiHash,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'genaiops-quality',
    name: 'Quality Score',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Overall quality rating',
    icon: REGISTRY_ICONS.FiStar,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'genaiops-prompts',
    name: 'Prompts Count',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total prompts in library',
    icon: REGISTRY_ICONS.FiFileText,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'genaiops-p95-latency',
    name: 'P95 Latency',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: '95th percentile response time',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'genaiops-p99-latency',
    name: 'P99 Latency',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: '99th percentile response time',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },

  // GENAIOPS WIDGETS (Additional)
  {
    id: 'tokens-by-model',
    name: 'Tokens by Model',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Token usage breakdown',
    icon: REGISTRY_ICONS.FiHash,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'cost-per-request',
    name: 'Cost per Request',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average cost per API call',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'latency-trend',
    name: 'Latency Trend',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Response time over time',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'evaluation-scores',
    name: 'Evaluation Scores',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Model performance metrics',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'genaiops',
    refreshRate: 600000,
    supportsDateFilter: true
  },
  {
    id: 'total-requests',
    name: 'Total Requests',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'API requests today',
    icon: REGISTRY_ICONS.FiPhone,
    dataSource: 'genaiops',
    refreshRate: 60000,
    supportsDateFilter: true
  },
  {
    id: 'active-models',
    name: 'Active Models',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Models in use',
    icon: REGISTRY_ICONS.FiCpu,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: false
  },
  {
    id: 'cache-hit-rate',
    name: 'Cache Hit Rate',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Response cache efficiency',
    icon: REGISTRY_ICONS.FiZap,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'user-feedback-score',
    name: 'User Feedback',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average feedback rating',
    icon: REGISTRY_ICONS.FiStar,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'prompt-versions',
    name: 'Prompt Versions',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Total prompt versions',
    icon: REGISTRY_ICONS.FiEdit,
    dataSource: 'genaiops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'model-performance',
    name: 'Model Performance',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Performance by model',
    icon: REGISTRY_ICONS.FiBarChart2,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'cost-over-time',
    name: 'Cost Over Time',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Historical LLM spending',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'token-usage-trend',
    name: 'Token Usage Trend',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Token consumption pattern',
    icon: REGISTRY_ICONS.FiTrendingUp,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'tokens-per-request',
    name: 'Tokens per Request',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average tokens/request',
    icon: REGISTRY_ICONS.FiHash,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'unique-users',
    name: 'Unique Users',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Active user count',
    icon: REGISTRY_ICONS.FiUsers,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'session-length',
    name: 'Avg Session Length',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Average session duration',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'cost-by-model',
    name: 'Cost by Model',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.MEDIUM,
    description: 'Spending per model',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'hallucination-rate',
    name: 'Hallucination Rate',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Factual accuracy issues',
    icon: REGISTRY_ICONS.FiAlertCircle,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'prompt-success-rate',
    name: 'Prompt Success',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Successful prompts',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'error-rate-trend',
    name: 'Error Rate Trend',
    category: C.GENAIOPS,
    type: T.CHART,
    defaultSize: S.LARGE,
    description: 'Error rate over time',
    icon: REGISTRY_ICONS.FiTrendingDown,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'session-cost',
    name: 'Session Cost',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Cost per session',
    icon: REGISTRY_ICONS.FiDollarSign,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'traces-per-session',
    name: 'Traces per Session',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Avg interaction count',
    icon: REGISTRY_ICONS.FiRefreshCw,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'session-duration',
    name: 'Session Duration',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Time in conversations',
    icon: REGISTRY_ICONS.FiClock,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'active-experiments',
    name: 'Active Experiments',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Running A/B tests',
    icon: REGISTRY_ICONS.FiPackage,
    dataSource: 'genaiops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
  {
    id: 'evaluation-pass-rate',
    name: 'Evaluation Pass Rate',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'Passing evaluations %',
    icon: REGISTRY_ICONS.FiCheckCircle,
    dataSource: 'genaiops',
    refreshRate: 300000,
    supportsDateFilter: true
  },
  {
    id: 'test-datasets-count',
    name: 'Test Datasets',
    category: C.GENAIOPS,
    type: T.METRIC,
    defaultSize: S.SMALL,
    description: 'LLM test collections',
    icon: REGISTRY_ICONS.FiBookOpen,
    dataSource: 'genaiops',
    refreshRate: 600000,
    supportsDateFilter: false
  },
];
